import React from "react";

import { PaziaBreadcrumbs } from "components/atoms";
import { PaziaHeader } from "components/atoms/PaziaHeader/PaziaHeader";

interface HeaderWithBreadcrumbsProps {
  headerText: string;
  breadcrumbs: {
    title: string;
    path?: string;
  }[];
  headerButton?: React.ReactNode;
  className?: string;
}

export const HeaderWithBreadcrumbs = ({
  headerText,
  breadcrumbs,
  headerButton,
  className = "",
}: HeaderWithBreadcrumbsProps): JSX.Element | null => {
  return (
    <div className={`flex flex-col gap-4 mb-4 ${className}`}>
      <PaziaBreadcrumbs segments={breadcrumbs} />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <PaziaHeader>{headerText}</PaziaHeader>
        {headerButton}
      </div>
    </div>
  );
};
